<mat-dialog-content class="mat-dialog-content">
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>OK</button>
</mat-dialog-actions>